import React, {useState, useEffect} from "react";
//import Modal from '@material-ui/core/Modal';
import {Modal, Button, ProgressBar} from "react-bootstrap";
import './imageSelector.css';
import api from '../../services/api';
import Camera, {FACING_MODES} from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

import Gallery from './Gallery'
import { ConsoleView } from "react-device-detect";

export default function ImageSelector({
    standard,
    handleChange,
    handleChangeStep,
    handleSelectImage,
    accept,
    idx,
    withImageBank,
    withSimpleUpload,
    iconSelect
  }) {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);
  const [imgstate, setImgState] = useState(standard.images ?? []);
  const [ camerr, setCamerr] = useState(false) 
  const [ errorType, setErrorType] = useState('')
  const mediatoken = localStorage.getItem('mediatoken');
  const [progressNumber, setProgressNumber] = useState(0);
  const handleShow = () => {
    setShow(true)
  }
  const handleClose = () => {
    if (accept === "image/*") {
      handleSelectImage(null);
    } else {

    }
    setShow(false);
  }

  //const listImages = standard.images ?? [];


  useEffect(() => {
    const nstandard = standard;
    nstandard.images = imgstate;
    handleChange(nstandard);
  }, [imgstate, handleChange, standard])

  const handleSelect = (e) => {
      setSelected(e);
      handleInsertAndClose(e)
  }   

    const handleSelectByGallery = (e) => {
        setSelected(e);        
        handleInsertAndClose(e)
  }     

  const handleInsert = (e) => {
    if (accept === "image/*") {      
        handleInsertAndClose(selected)
    } else {
      //handleUploadFile(e);

    }
    }

    const handleInsertAndClose = (img) => {
        if (accept === "image/*") {
            setShow(false);
            const [url, token] = img.split('?');
            handleSelectImage(url);
        } else {
            //handleUploadFile(e);
        }
    }

  const deleteImage = () => {
    let filteredArray = imgstate.filter(item => item !== selected);
    setImgState(filteredArray);
    localStorage.removeItem(selected);
  }

  const imageStorage = (e) => {
    //const file = getImage(img);
    console.log("storage");
    console.log(e);

    const config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: function (progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          setProgressNumber(percentCompleted);
      }
    }

    if (e) {
      const file = e.target.files[0];
      var formData = new FormData();
      formData.append(file.name.toLowerCase(), file);
      api.post('standard/uploadFiles', formData, config)
      .then((response) => {
          setProgressNumber(0);
          if (accept === "image/*") {
              setImgState([response.data[file.name.toLowerCase()] + addToken(), ...imgstate]);
            //return response.data;
          } else {
            var newstep = standard.steps[idx];
            var obj = response.data;
            var filePath = obj[Object.keys(obj)[0]];
            newstep.content = filePath;
            //handleChange(nstandard);
            handleChangeStep(newstep, idx);
            handleClose();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

    function addToken() {
        return '?' + mediatoken
    }

  function dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    let blob = new Blob([ab], {type: mimeString});
    return blob;
  }


  function getImage(base64) {
    //var base64 = localStorage[img];
    //console.log(base64.slice(23));
    var base64Parts = base64.split(",");
    var fileFormat = base64Parts[0].split(";")[1];
    var fileContent = dataURItoBlob(base64); //base64.slice(23); //base64Parts[1];
    const img = 'standard-' + Date.now() + ".png";
    var file = new File([fileContent], img, {type: 'image/png'});
    return file;
  }

  const [cam, setCam] = useState(false);

  function handleTakePhoto(base64) {
    const file = getImage(base64);
    imageStorage({target: {files: [file]}});
    console.log(file);
  }

  if (iconSelect == "Camera") {
    var Icon = <i className="icon fas fa-camera"/>
  }else{
    var Icon = <i className="icon far fa-images"/>
  }

  function errorCam(error){
    console.log('er', error.toString())
    if(error.toString() == 'NotAllowedError: Permission denied'){
      console.log('er 01', error)
      setErrorType(': não há permissão de câmera')
    }
    if(error.toString() == 'NotFoundError: Requested device not found'){
      console.log('er 02', error)
      setErrorType(': não há dispositivo de câmera')
    }
    // setErrorType()
    setCamerr(true)
    setCam(false)
  }

  return (
    <>
      {accept === "image/*" &&
      <Button type="button" className=" btn btn-outline-secondary btn-icon"
              onClick={handleShow}>
              {Icon}
      </Button>
      }
      {accept !== "image/*" &&
      <button className='mx-2' onClick={handleShow}>selecionar arquivo</button>
      }

      <Modal show={show} onHide={handleClose} size='xl' style={{maxHeight:'99vh', width:'99vw'}}>
        <Modal.Header closeButton>
          <Modal.Title>{withImageBank ? 'Selecione uma imagem' : 'Selecione uma imagem do seu dispositivo ou tire uma foto'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {withSimpleUpload &&
          <div>{
                  camerr ? <div>a camera não está funcionando{errorType}</div>:null
                }
            {cam && 
              <Camera 
                isFullscreen={true} 
                isImageMirror={false} 
                idealFacingMode={FACING_MODES.ENVIRONMENT} 
                onCameraStart={(e)=> setCamerr(false)} 
                onCameraError={(e)=> errorCam(e)} 
                onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); setCam(false) } }
                
                />
              }
            <p>
              <Button type="button" className="btn btn-outline-secondary btn-icon"
                      onClick={() => {setCam(true); setShow(true)}} >
                <i className="icon fas fa-camera" />
              </Button>
              <input
                type="file"
                id="imageFile"
                name='imageFile'
                onChange={imageStorage}
                accept={accept}
              />
              {
                progressNumber !== 0 &&
                <ProgressBar className={'w-100 d-block'} style={{ height: '30px' }} now={progressNumber} variant="success"
                    label={`${progressNumber}%`} />
              }
            </p>
            {accept==="image/*" && imgstate.map((img,idx) => (
              <div key={idx}>
                <img id={img} alt={img}
                     height='150vh'
                     className={(selected === img) ? "selected" : "unselected"}
                     src={img ?? ''}
                     onClick={handleSelect.bind(this, img)}
                />
              </div>
            ))}
          </div>
          }
          {withImageBank &&
          <Gallery onClick={handleSelectByGallery.bind(this)}/>
          }
        </Modal.Body>
        <Modal.Footer>         
          <Button variant="primary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

// async function getBase64(url) {
//     return axios
//       .get(url, {
//         responseType: 'arraybuffer'
//       })
//       .then(response =>
//         Buffer.from(response.data, 'binary').toString('base64')
//       );

//   }

//   function getImage(img) {
//     var base64 = localStorage[img];
//     var base64Parts = base64.split(",");
//     var fileFormat = base64Parts[0].split(";")[1];
//     var fileContent = base64Parts[1];
//     var file = new File([fileContent], img, {type: fileFormat});
//     return file;
//   }

//   const imageLocal = (e) => {
//     const file = e.target.files[0];
//     console.log(file);
//     getBase64(file).then(base64 => {
//     localStorage[file.name] = base64;
//     setImgState([file.name, ...imgstate]);
//     });
//   }

// const getBase64 = (file) => {
//   return new Promise((resolve,reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//     reader.readAsDataURL(file);
//   });
// }
